module.exports = {
    HOME_TITLE: "主页",
    PAGE_TABS: [{
        title: "主页",
        url: '/console',
        checked: true
    }],
    // baseUrl: "http://127.0.0.1:8002/",
    // baseUrl: "http://47.108.189.131:8002/",
    baseUrl: "https://www.scjytech.com/wpchse-api",
    serverTimeout: 50000,
    version: "v1.0.1"
}